import { render, staticRenderFns } from "./EditTaskDialog.vue?vue&type=template&id=6f39ed41&"
import script from "./EditTaskDialog.vue?vue&type=script&lang=js&"
export * from "./EditTaskDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EditTaskDialog.vue"
export default component.exports